'use client';
import {
  LAZY_SECTION_IN_VIEW_OPTIONS,
  useInView,
} from '@/shared/hooks/useInView';
import { DynamicProvidersSection } from './dynamic-providers-section';
import { ProvidersLazyWrapper } from './styles';

export const ProvidersLazySection = () => {
  const [ref, isVisible] = useInView(LAZY_SECTION_IN_VIEW_OPTIONS);

  return (
    <ProvidersLazyWrapper ref={ref}>
      {isVisible && <DynamicProvidersSection />}
    </ProvidersLazyWrapper>
  );
};
